import Education from "./Education";
import Experience from "./Experience";
import Leadership from "./Leadership";
import useTranslations from "@hooks/useTranslations";

const CV = () => {
  const t = useTranslations();

  return (
    <div className="bostami-page-content-wrap">
      <div className="section-wrapper pl-60 pr-60 pt-60">
        <div className="bostami-page-title-wrap mb-15">
          <h1 className="page-title">{t.cv.title}</h1>
        </div>
      </div>

      {/* Une ligne pleine largeur par bloc, dans l'ordre du CV. */}
      <div className="section-wrapper pl-60 pr-60 mb-60">
        <div className="row">
          <Education />
        </div>
        <div className="row">
          <Experience type="dev" />
        </div>
        <div className="row">
          <Experience type="formation" />
        </div>
        <div className="row">
          <Leadership />
        </div>
      </div>
    </div>
  );
};

export default CV;
